"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrendsChartConfig = void 0;
var _types = require("../types");
var _getCustoms = require("./getCustoms");
var _getChartData = require("./getChartData");
var _locale = require("date-fns/locale");
var _constants = require("./constants");
var _utils = require("./utils");
var _crosshairPlugin = require("./crosshairPlugin");
var _controlHoverStatePlugin = require("./controlHoverStatePlugin");
var _config = require("./config.setHoverEvents");
var _config2 = require("./config.pointRadius");
var _config3 = require("./config.setEvents");
var _getChartConfig = require("./getChartConfig");
const getTrendsChartConfig = params => {
  const {
    props
  } = params;
  const {
    data: {
      xScale
    },
    verticalPadding,
    isDesktop
  } = props;
  const plugins = [];
  if (props.type === _types.EChartTypes.SupplyDemand) {
    plugins.push((0, _controlHoverStatePlugin.getControlHoverStatePlugin)(isDesktop));
  } else {
    plugins.push((0, _crosshairPlugin.crosshairPlugin)(props.logger), (0, _controlHoverStatePlugin.getControlHoverStatePlugin)(isDesktop));
  }
  const customs = (0, _getCustoms.getCustoms)(props);
  const cfg = {
    type: 'line',
    data: (0, _getChartData.getChartData)(params),
    options: {
      maintainAspectRatio: false,
      parsing: {
        xAxisKey: 'reportDate',
        yAxisKey: 'value'
      },
      interaction: {
        intersect: false,
        mode: 'nearest',
        axis: 'x'
      },
      scales: {
        x: {
          type: 'time',
          time: {
            unit: xScale,
            displayFormats: {
              month: 'LLL yy',
              day: 'dd MMM'
            },
            tooltipFormat: 'dd MMMM yyyy'
          },
          adapters: {
            date: {
              locale: _locale.ru
            }
          },
          ticks: {
            color: _constants.TICKS_FONT_COLOR,
            padding: 6,
            maxRotation: 0,
            autoSkipPadding: 20
          },
          grid: {
            drawOnChartArea: false,
            color: _constants.BORDER_COLOR,
            lineWidth: 1,
            borderColor: _constants.BORDER_COLOR,
            //цвет нижней границы графика
            tickColor: _constants.TICKS_COLOR,
            tickLength: 4
          }
        },
        y: {
          beginAtZero: props.type === _types.EChartTypes.SupplyDemand,
          suggestedMin: (0, _utils.ensureScriptable)((0, _getChartConfig.suggestedMin)(verticalPadding)),
          suggestedMax: (0, _utils.ensureScriptable)((0, _getChartConfig.suggestedMax)(verticalPadding)),
          grid: {
            drawOnChartArea: true,
            drawBorder: false,
            drawTicks: false,
            color: _getChartConfig.yGridColor
          },
          ticks: {
            stepSize: props.type === _types.EChartTypes.SupplyDemand ? 100 : undefined,
            color: _constants.TICKS_FONT_COLOR,
            padding: 6,
            callback: tickValue => (0, _getChartConfig.yTicksCallback)(tickValue, props.type),
            count: props.type === _types.EChartTypes.SupplyDemand ? undefined : 3
          }
        }
      },
      elements: {
        point: {
          hoverBorderWidth: _constants.POINT_BORDER_WIDTH,
          hoverRadius: props.type === _types.EChartTypes.SupplyDemand ? 0 : _constants.POINT_HOVER_RADIUS,
          borderColor: customs.BG_COLOR,
          borderWidth: _constants.POINT_BORDER_WIDTH
        },
        line: {
          borderWidth: 2
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: props.type === _types.EChartTypes.Trends,
          backgroundColor: '#152242',
          titleColor: 'rgba(255, 255, 255, 0.6)',
          cornerRadius: 4,
          caretSize: 0,
          caretPadding: 12,
          callbacks: {
            label: tooltipItem => (0, _getChartConfig.tooltipLabelCb)(tooltipItem, props.activeFilter),
            title: _getChartConfig.prettifyTooltipTitle
          },
          boxWidth: 7,
          boxHeight: 7,
          boxPadding: 4,
          usePointStyle: true
        }
      },
      layout: {
        autoPadding: true,
        padding: {
          left: -2,
          right: 8
        }
      }
    },
    plugins
  };
  (0, _config.setHoverEvents)(cfg, props);
  (0, _config2.setPointRadius)(cfg, props);
  (0, _config3.setEvents)(cfg, props);
  return cfg;
};
exports.getTrendsChartConfig = getTrendsChartConfig;